const COLORS = {
  PRIMARY: '#212121',
  WHITE_HIGH: '#ffffff',
  WHITE_MEDIUM: 'rgba(255, 255, 255, 0.5)',
  WHITE_DISABLED: 'rgba(255, 255, 255, 0.3)',
  BLACK_HIGH: '#212121',
  BLACK_MEDIUM: 'rgba(0, 0, 0, 0.5)',
  BLACK_DISABLED: 'rgba(0, 0, 0, 0.3)',
  BORDER_COLOR: '#D3D3D3'
};

const SUB_TITLE_HIGH = {
  fontWeight: 'bold',
  fontSize: 16,
  lineHeight: 24,
  fontStyle: 'normal',
};

const SUB_TITLE_MEDIUM = {
  fontWeight: '500',
  fontSize: 14,
  lineHeight: 20,
  fontStyle: 'normal',
};

const SUB_TITLE_DISABLED = {
  fontWeight: '500',
  fontSize: 12,
  lineHeight: 16,
  fontStyle: 'normal',
};

const BLACK_SUB_TITLE_HIGH = {
  ...SUB_TITLE_HIGH,
  color: COLORS.BLACK_HIGH,
};

const BLACK_SUB_TITLE_MEDIUM = {
  ...SUB_TITLE_MEDIUM,
  color: COLORS.BLACK_MEDIUM,
};

const BLACK_SUB_TITLE_DIABLED = {
  ...SUB_TITLE_DISABLED,
  color: COLORS.BLACK_DISABLED,
};

const WHITE_SUB_TITLE_HIGH = {
  ...SUB_TITLE_HIGH,
  color: COLORS.WHITE_HIGH,
};

const WHITE_SUB_TITLE_MEDIUM = {
  ...SUB_TITLE_MEDIUM,
  color: COLORS.WHITE_MEDIUM,
};

const WHITE_SUB_TITLE_DIABLED = {
  ...SUB_TITLE_DISABLED,
  color: COLORS.WHITE_DISABLED,
};

export {
  COLORS,
  SUB_TITLE_MEDIUM,
  BLACK_SUB_TITLE_HIGH,
  BLACK_SUB_TITLE_MEDIUM,
  BLACK_SUB_TITLE_DIABLED,
  WHITE_SUB_TITLE_HIGH,
  WHITE_SUB_TITLE_MEDIUM,
  WHITE_SUB_TITLE_DIABLED,
};
